import React from 'react'

import Card from '../../../UI/Card/Card'
import CardHeader from '../../../UI/Card/Header/Header'
import CardBody from '../../../UI/Card/Body/Body'
import CardFooter from '../../../UI/Card/Footer/Footer'

import Pagination from '../../../UI/Pagination/Pagination'

import ActionBar from '../../../../components/ActionBar/ActionBar'
import HeaderActions from './HeaderActions/HeaderActions'

import EmployeeData from './EmployeeData/EmployeeData'
import PageInfo from '../../../PageInfo/PageInfo'

const employeeContent = ({
  employeeData,
  loading,
  deleting,
  empSelected,
  selectedEmps,
  pagination,
  perPageChanged,
  pageChange,
  addDisabled,
  editDisabled,
  deleteDisabled,
  exporting,
  importing,
  downloading,
  filtering,
  importDisabled,
  filterText,
  filterTextChanged
}) => {
  return (
    <Card>
      <CardHeader
        title={
          <ActionBar
            exporting={exporting}
            importing={importing}
            downloading={downloading}
            filtering={filtering}
            importDisabled={importDisabled}
            leftContent={<PageInfo pageTranslateKey={'employee'} />}
          />
        }
      />
      <CardHeader
        title={
          <HeaderActions
            addDisabled={addDisabled}
            deleteClicked={deleting}
            deleteDisabled={selectedEmps.length < 1 || deleteDisabled}
            filterText={filterText}
            filterTextChanged={filterTextChanged}
          />
        }
      />
      <CardBody>
        <EmployeeData
          editDisabled={editDisabled}
          records={employeeData}
          loading={loading}
          onEmpSelected={empSelected}
          selectedEmps={selectedEmps}
        />
      </CardBody>
      <CardFooter>
        <Pagination
          pagination={pagination}
          perPageChanged={perPageChanged}
          pageChanged={pageChange}
        />
      </CardFooter>
    </Card>
  )
}

export default employeeContent
